
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["render"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "3564c6963cd88921f9c9.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			